import 'element.prototype.matches'; // IE11, https://caniuse.com/#feat=matchesselector
import 'custom-event-polyfill'; // IE11, https://caniuse.com/#feat=customevent
import 'mutation-observer-inner-html-shim'; // IE11, https://caniuse.com/#search=MutationObserver
import 'browser-environment';

import App from '@/scripts/core/App';

import ProductGallery from '@/scripts/components/ProductGallery';
import ImageCropper from '@/scripts/components/ImageCropper';
import LazyBlock from '@/scripts/components/LazyBlock';
import Choices from '@/scripts/components/Choices';
import Catalog from '@/scripts/components/Catalog';

import scrollTo from '@/scripts/directives/scrollTo';
import lazyImage from '@/scripts/directives/lazyImage';

import './old';

const Clipboard = () => import('@/scripts/components/Clipboard');
const HappyChildGame = () => import('@/scripts/components/HappyChildGame');
const IntlTelInput = () => import('@/scripts/components/IntlTelInput');
const GiftCertificateForm = () => import('@/scripts/components/GiftCertificateForm');

const CrowdCampaignForm = () => import(/* webpackChunkName: "crowd" */ '@/scripts/components/CrowdCampaignForm');
const CrowdCampaignPersonalForm = () => import(/* webpackChunkName: "crowd" */ '@/scripts/components/CrowdCampaignPersonalForm');
const CrowdCampaignMoneyForm = () => import(/* webpackChunkName: "crowd" */ '@/scripts/components/CrowdCampaignMoneyForm');

window.newApp = new App({
  el: '#app',
  components: {
    ImageCropper,
    Choices,
    LazyBlock,
    Catalog,
    ProductGallery,
    Clipboard,
    CrowdCampaignForm,
    CrowdCampaignPersonalForm,
    CrowdCampaignMoneyForm,
    HappyChildGame,
    IntlTelInput,
    GiftCertificateForm,
  },
  directives: {
    scrollTo,
    lazyImage,
  },
  methods: {},
  data: window.AppConfig || {},
});
